import { initElmApp } from 'elm/utilities'
import * as GeoPieMapContainer from 'elm/src/GeoPieMap/Container.elm'
import { GeoPieMap } from 'visualizations/geo-pie-map'
import type { SliceEvent, HighlightedSlice, NodesData, Settings, Visualization } from 'visualizations/geo-pie-map/types'
import { Event } from 'visualizations/geo-pie-map/types'

export function init (): void {
  const app = initElmApp(GeoPieMapContainer)
  const targetContainer = document.getElementById('geo_pie_map') as HTMLElement

  const map = new GeoPieMap(targetContainer)

  app.ports.initialize.subscribe((data: { settings: Settings }) => {
    map.initialize(data.settings)
  })

  app.ports.render.subscribe((visualization: Visualization) => {
    map.render(visualization)

    map.on(Event.SLICE_CLICKED, ({ pieId, sliceId }: SliceEvent) => {
      app.ports.sliceClicked.send({
        locationId: pieId,
        categoryId: sliceId
      })
    })

    map.on(Event.SLICE_HOVERED, ({ pieId, sliceId }: SliceEvent) => {
      app.ports.sliceHovered.send({
        locationId: pieId,
        categoryId: sliceId
      })
    })

    map.on(Event.SLICE_UNHOVERED, ({ pieId, sliceId }: SliceEvent) => {
      app.ports.sliceUnhovered.send({
        locationId: pieId,
        categoryId: sliceId
      })
    })

    map.on(Event.NODE_CLICKED, ({ nodeId }: NodeEvent) => {
      layoverController().load(nodeId, 'card')
    })

    app.ports.highlightSlices.subscribe((slices: HighlightedSlice[]) => {
      map.publish(Event.HIGHLIGHT_SLICES, slices)
    })

    app.ports.addNodes.subscribe((data: NodesData) => {
      map.publish(Event.ADD_NODES, data)
    })

    app.ports.hideNodes.subscribe((data: NodesData) => {
      map.publish(Event.HIDE_NODES, data)
    })

    app.ports.showNodes.subscribe((data: NodesData) => {
      map.publish(Event.SHOW_NODES, data)
    })
  })
}

const layoverController = (): object => {
  return globalThis._APPLICATION_.getControllerForElementAndIdentifier(document.getElementById('layover'), 'layover')
}
